import type { Outcome } from '../../../../../api/strategy-client';
import { useTranslation } from 'react-i18next';
import { inkLight, secondaryBase } from '../../../../../styles/design-tokens';
import { Text } from '../../../../../ui-library/typography/typography';
import { FiltersList } from './filters-list';

type Props = {
  outcomes: Outcome[];
  selectedOutcomes: Outcome[];
  onSelectOutcomes: (outcomes: Outcome[]) => void;
};

export const FiltersListOutcomes = ({ outcomes, selectedOutcomes, onSelectOutcomes }: Props) => {
  const i18n = useTranslation();
  const getTasksDone = (outcome: Outcome) => {
    let tasksCompleted = 0;
    Object.values(outcome.contributing_teams_over_time || {}).forEach((team) => {
      Object.values(team.tasks || {}).forEach((count) => {
        tasksCompleted += count || 0;
      });
    });
    return tasksCompleted;
  };

  return (
    <FiltersList
      items={outcomes}
      selectedItems={selectedOutcomes}
      onSelectItems={onSelectOutcomes}
      getItemName={(outcome) => outcome.name}
      getItemLabel={(outcome) => (
        <>
          <Text size="small" color={secondaryBase} style={{ lineHeight: '20px' }}>
            {outcome.key}
          </Text>
        </>
      )}
      getItemDescription={(outcome) => (
        <Text size="small" style={{ lineHeight: '20px' }}>
          {outcome.name}
        </Text>
      )}
      getItemExtraInfo={(outcome) => {
        const tasksDone = getTasksDone(outcome);
        return (
          <Text size="small" color={inkLight}>
            {`${tasksDone} ${(tasksDone === 1 ? i18n.t('common.work_unit') : i18n.t('common.work_units')).toLowerCase()}`}
          </Text>
        );
      }}
    />
  );
};
